// src/data/galleryImages.ts
export interface GalleryImage {
  id: string;
  src: string;
  alt: string;
  category: string;
  description: string;
  featured: boolean;
  tags?: string[];
  priceRange?: string;
  duration?: string;
}

export const galleryImages: GalleryImage[] = [
  {
    id: '1',
    src: '/images/gallery/adinkra-nails.jpg',
    alt: 'Adinkra symbol nail art design',
    category: 'Traditional',
    description: 'Hand-painted Sankofa and Gye Nyame Adinkra symbols representing wisdom and strength. Perfect for cultural celebrations and traditional weddings.',
    featured: true,
    tags: ['Adinkra', 'Hand-painted', 'Traditional'],
    priceRange: '₵120 - ₵180',
    duration: '75-90 min'
  },
  {
    id: '2',
    src: '/images/gallery/kente-design.jpg',
    alt: 'Kente pattern nail design',
    category: 'Traditional',
    description: 'Intricate Kente cloth patterns recreated on nails with gold foil accents. Inspired by Ashanti royalty and Ghanaian heritage.',
    featured: true,
    tags: ['Kente', 'Geometric', 'Gold Foil'],
    priceRange: '₵150 - ₵200',
    duration: '90 min'
  },
  {
    id: '3',
    src: '/images/gallery/accra-skyline.jpg',
    alt: 'Accra skyline nail art design',
    category: 'Modern',
    description: 'Modern minimalist design featuring Accra\'s iconic skyline with Independence Arch and city landmarks in silhouette.',
    featured: true,
    tags: ['Accra', 'Minimalist', 'Cityscape'],
    priceRange: '₵100 - ₵140',
    duration: '60 min'
  },
  {
    id: '4',
    src: '/images/gallery/afro-chic.jpg',
    alt: 'Afro-chic nail art design',
    category: 'Modern',
    description: 'Contemporary Afro-chic design with Ankara fabric patterns and bold color blocking. Perfect for fashion events in Accra.',
    featured: true,
    tags: ['Ankara', 'Color Block', 'Modern'],
    priceRange: '₵110 - ₵160',
    duration: '65 min'
  },
  {
    id: '5',
    src: '/images/gallery/wedding-nails.jpg',
    alt: 'Bridal nail art for Ghanaian wedding',
    category: 'Bridal',
    description: 'Elegant bridal set with delicate lace patterns and pearl accents. Designed for traditional Ghanaian wedding ceremonies.',
    featured: true,
    tags: ['Bridal', 'Pearls', 'Lace'],
    priceRange: '₵200 - ₵300',
    duration: '120 min'
  },
  {
    id: '6',
    src: '/images/gallery/corporate-nails.jpg',
    alt: 'Professional nails for corporate settings',
    category: 'Corporate',
    description: 'Sophisticated neutral tones perfect for Accra\'s corporate professionals. Clean, elegant, and office-appropriate.',
    featured: false,
    tags: ['Professional', 'Neutral', 'Office'],
    priceRange: '₵80 - ₵120',
    duration: '45 min'
  },
  {
    id: '7',
    src: '/images/gallery/french-tip.jpg',
    alt: 'French tip nails with Ghanaian gold accents',
    category: 'Classic',
    description: 'Classic French tip reimagined with Ghanaian gold leaf detailing. Elegant design suitable for any occasion in Accra.',
    featured: false,
    tags: ['French Tip', 'Gold Leaf', 'Classic'],
    priceRange: '₵90 - ₵130',
    duration: '50 min'
  },
  {
    id: '8',
    src: '/images/gallery/colour-block.jpg',
    alt: 'Color block nail design',
    category: 'Modern',
    description: 'Bold color blocking inspired by Ghana\'s vibrant festivals. Bright colors representing joy and celebration.',
    featured: false,
    tags: ['Festival', 'Bright Colors', 'Geometric'],
    priceRange: '₵100 - ₵150',
    duration: '55 min'
  },
  {
    id: '9',
    src: '/images/gallery/ombre-nails.jpg',
    alt: 'Ombre nail design with sunset colors',
    category: 'Modern',
    description: 'Smooth ombre transition from sunset orange to deep purple, inspired by Ghanaian coastal sunsets.',
    featured: false,
    tags: ['Ombre', 'Sunset', 'Gradient'],
    priceRange: '₵120 - ₵170',
    duration: '70 min'
  },
  {
    id: '10',
    src: '/images/gallery/geometric-abstract.jpg',
    alt: 'Geometric abstract nail art',
    category: 'Modern',
    description: 'Abstract geometric patterns with metallic accents. Modern design for Accra\'s fashion-forward clients.',
    featured: true,
    tags: ['Abstract', 'Geometric', 'Metallic'],
    priceRange: '₵130 - ₵180',
    duration: '80 min'
  },
  {
    id: '11',
    src: '/images/gallery/3d-nail-art.jpg',
    alt: '3D nail art with beads and charms',
    category: 'Luxury',
    description: 'Luxurious 3D nail art featuring Swarovski crystals, beads, and traditional Ghanaian charms.',
    featured: true,
    tags: ['3D Art', 'Crystals', 'Luxury'],
    priceRange: '₵250 - ₵350',
    duration: '120-150 min'
  },
  {
    id: '12',
    src: '/images/gallery/men-grooming.jpg',
    alt: 'Men\'s nail grooming and care',
    category: 'Men',
    description: 'Professional nail grooming service for men. Clean, healthy nails with subtle buffing and shaping.',
    featured: false,
    tags: ['Men', 'Grooming', 'Clean'],
    priceRange: '₵60 - ₵90',
    duration: '30 min'
  },
  {
    id: '13',
    src: '/images/gallery/christmas-special.jpg',
    alt: 'Christmas holiday nail design',
    category: 'Seasonal',
    description: 'Festive Christmas design with red, green, and gold accents. Perfect for holiday parties in Accra.',
    featured: false,
    tags: ['Christmas', 'Holiday', 'Festive'],
    priceRange: '₵140 - ₵190',
    duration: '85 min'
  },
  {
    id: '14',
    src: '/images/gallery/independence-theme.jpg',
    alt: 'Ghana Independence Day nail art',
    category: 'Traditional',
    description: 'Patriotic design featuring Ghana flag colors and independence motifs for March 6th celebrations.',
    featured: false,
    tags: ['Independence', 'Flag Colors', 'Patriotic'],
    priceRange: '₵110 - ₵160',
    duration: '75 min'
  },
  {
    id: '15',
    src: '/images/gallery/matte-finish.jpg',
    alt: 'Matte finish nail design',
    category: 'Modern',
    description: 'Elegant matte finish with subtle texture. Modern and sophisticated for Accra\'s style-conscious clients.',
    featured: false,
    tags: ['Matte', 'Textured', 'Modern'],
    priceRange: '₵100 - ₵140',
    duration: '60 min'
  },
  {
    id: '16',
    src: '/images/gallery/glitter-glam.jpg',
    alt: 'Glitter glam nail design',
    category: 'Party',
    description: 'Full glitter glam design perfect for Accra nightlife, parties, and special events.',
    featured: false,
    tags: ['Glitter', 'Party', 'Glam'],
    priceRange: '₵130 - ₵180',
    duration: '80 min'
  }
];

// Helper functions
export const getFeaturedImages = (): GalleryImage[] => {
  return galleryImages.filter(img => img.featured);
};

export const getImagesByCategory = (category: string): GalleryImage[] => {
  return galleryImages.filter(img => img.category.toLowerCase() === category.toLowerCase());
};

export const getAllCategories = (): string[] => {
  const categories = galleryImages.map(img => img.category);
  return Array.from(new Set(categories));
};

export const getImageById = (id: string): GalleryImage | undefined => {
  return galleryImages.find(img => img.id === id);
};